<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <!-- messageSenderInformation -->
      <section>
        <fieldset>
          <legend>
            {{ pageVocabs + "bankOnlineGatewaysForm" | translate }}
          </legend>

          <div class="row">
            <!-- accountInformationId -->
            <div class="sm:tw-w-1/2">
              <account-information-select-search
                [organizationId]="userSession.organizationId()"
                [control]="form?.get('accountInformationId')"
                [(value)]="model.accountInformationId"
                (onError)="onClose()"
              >
              </account-information-select-search>
            </div>

            <!-- typeIPG -->
            <div class="sm:tw-w-1/2">
              <enum-select-search
                class="tw-w-full"
                enumName="TypeIPGs"
                [label]="fields + 'typeIPG'"
                [control]="form?.get('typeIPG')"
                [(value)]="model.typeIpg"
                (valueChange)="showBankConfigSelected($event)"
                (onError)="onClose()"
              >
              </enum-select-search>
            </div>
          </div>

          <div class="row">
            <!-- userName -->
            <div
              class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4"
              *ngIf="userNameActive"
            >
              <form-field
                [(value)]="bankConfig.UserName"
                [control]="form?.get('userName')"
                label="common.userName"
                classList="dir-ltr"
              >
              </form-field>
            </div>

            <!-- password -->
            <div
              class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4"
              *ngIf="passwordActive"
            >
              <form-field
                type="password"
                [(value)]="bankConfig.Password"
                [control]="form?.get('password')"
                [isShowValidationStatusIcon]="false"
                label="common.password"
                classList="dir-ltr"
              >
              </form-field>
            </div>

            <!-- userPassword -->
            <div
              class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4"
              *ngIf="userPasswordActive"
            >
              <form-field
                [(value)]="bankConfig.UserPassword"
                [control]="form?.get('userPassword')"
                label="common.userPassword"
                classList="dir-ltr"
              >
              </form-field>
            </div>

            <!-- merchantId -->
            <div
              class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4"
              *ngIf="merchantIdActive"
            >
              <form-field
                [(value)]="bankConfig.MerchantId"
                [control]="form?.get('merchantId')"
                label="common.merchantId"
                classList="dir-ltr"
              >
              </form-field>
            </div>

            <!-- terminalId -->
            <div
              class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4"
              *ngIf="terminalIdActive"
            >
              <form-field
                [(value)]="bankConfig.TerminalId"
                [control]="form?.get('terminalId')"
                label="common.terminalId"
                classList="dir-ltr"
              >
              </form-field>
            </div>
            <!-- terminalKey -->
            <div
              class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4"
              *ngIf="terminalKeyActive"
            >
              <form-field
                [(value)]="bankConfig.TerminalKey"
                [control]="form?.get('terminalKey')"
                label="common.terminalKey"
                classList="dir-ltr"
              >
              </form-field>
            </div>

            <!-- shaKey -->
            <div
              class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4"
              *ngIf="shaKeyActive"
            >
              <form-field
                [(value)]="bankConfig.ShaKey"
                [control]="form?.get('shaKey')"
                label="common.shaKey"
              >
              </form-field>
            </div>

            <!-- loginAccount -->
            <div
              class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4"
              *ngIf="loginAccountActive"
            >
              <form-field
                [(value)]="bankConfig.LoginAccount"
                [control]="form?.get('loginAccount')"
                label="common.loginAccount"
              >
              </form-field>
            </div>

            <!-- merchantCode -->
            <div
              class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4"
              *ngIf="merchantCodeActive"
            >
              <form-field
                [(value)]="bankConfig.MerchantCode"
                [control]="form?.get('merchantCode')"
                label="common.merchantCode"
                classList="dir-ltr"
              >
              </form-field>
            </div>

            <!-- privateKey -->
            <div
              class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4"
              *ngIf="privateKeyActive"
            >
              <form-field
                [(value)]="bankConfig.PrivateKey"
                [control]="form?.get('privateKey')"
                label="common.privateKey"
                classList="dir-ltr"
              >
              </form-field>
            </div>

            <!-- privateCode -->
            <div
              class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4"
              *ngIf="privateCodeActive"
            >
              <form-field
                [(value)]="bankConfig.PrivateCode"
                [control]="form?.get('privateCode')"
                label="common.privateCode"
                classList="dir-ltr"
              >
              </form-field>
            </div>

            <!-- IV -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4" *ngIf="IVActive">
              <form-field
                [(value)]="bankConfig.IV"
                [control]="form?.get('IV')"
                label="IV"
              >
              </form-field>
            </div>

            <!-- key -->
            <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4" *ngIf="keyActive">
              <form-field
                [(value)]="bankConfig.Key"
                [control]="form?.get('key')"
                label="common.key"
                classList="dir-ltr"
              >
              </form-field>
            </div>

            <!-- merchantConfigId -->
            <div
              class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4"
              *ngIf="merchantConfigIdActive"
            >
              <form-field
                [(value)]="bankConfig.MerchantConfigurationId"
                [control]="form?.get('merchantConfigId')"
                label="common.merchantConfigurationId"
                classList="dir-ltr"
              >
              </form-field>
            </div>

            <!-- acceptorId -->
            <div
              class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4"
              *ngIf="acceptorIdActive"
            >
              <form-field
                [(value)]="bankConfig.acceptorId"
                [control]="form?.get('acceptorId')"
                label="common.acceptorId"
                classList="dir-ltr"
              >
              </form-field>
            </div>

            <!-- passPhrase -->
            <div
              class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4"
              *ngIf="passPhraseActive"
            >
              <form-field
                [(value)]="bankConfig.passPhrase"
                [control]="form?.get('passPhrase')"
                label="common.passPhrase"
                classList="dir-ltr"
              >
              </form-field>
            </div>

            <!-- publicKey -->
            <div
              class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4"
              *ngIf="publicKeyActive"
            >
              <form-field
                [(value)]="bankConfig.publicKey"
                [control]="form?.get('publicKey')"
                label="common.publicKey"
                classList="dir-ltr"
              >
              </form-field>
            </div>
          </div>

          <div class="row tw-mb-3 tw-flex">
            <!-- isActive -->
            <div>
              <div class="checkbox-section tw-mt-5">
                <mat-slide-toggle
                  formControlName="isActive"
                  [(ngModel)]="model.isActive"
                >
                  {{ "common.active" | translate }}
                </mat-slide-toggle>
              </div>
            </div>

            <!-- isGeneralUse -->
            <div>
              <div class="checkbox-section tw-mt-5">
                <mat-slide-toggle
                  formControlName="isGeneralUse"
                  [(ngModel)]="model.isGeneralUse"
                >
                  {{ "common.generalUse" | translate }}
                </mat-slide-toggle>
              </div>
            </div>

            <!-- isFactorUse -->
            <div>
              <div class="checkbox-section tw-mt-5">
                <mat-slide-toggle
                  formControlName="isFactorUse"
                  [(ngModel)]="model.isFactorUse"
                >
                  {{ "common.usingTheInvoice" | translate }}
                </mat-slide-toggle>
              </div>
            </div>
          </div>
        </fieldset>
      </section>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
